import { render, staticRenderFns } from "./ElibraryBuletinView.vue?vue&type=template&id=52a6d123&scoped=true"
import script from "./ElibraryBuletinView.vue?vue&type=script&lang=js"
export * from "./ElibraryBuletinView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a6d123",
  null
  
)

export default component.exports